import { PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 13B: "Witaj w społeczności" - wariant z numerowanymi blokami i podtytułami
 */
export const InstagramStoryShare13B = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img src={bgImage} alt="" draggable={false} data-export-bg="true" loading="eager" decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }} />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "#4E8A6E", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "160px 72px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Welcome */}
        <h1 style={{ fontSize: "64px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 20px", textAlign: "center", lineHeight: 1.2 }}>
          Hej! 👋
        </h1>
        <p style={{ fontSize: "44px", fontWeight: 600, color: "#4A7A5E", margin: "0 0 8px", textAlign: "center", lineHeight: 1.4 }}>
          Skoro tu jesteś,
        </p>
        <p style={{ fontSize: "56px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 36px", textAlign: "center", lineHeight: 1.2 }}>
          masz dobre serduszko 💚
        </p>

        <div style={{ height: "24px" }} />

        <div style={{ width: "100px", height: "6px", background: "#4E8A6E", borderRadius: "3px", marginBottom: "36px" }} />

        <p style={{ fontSize: "44px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 56px", textAlign: "center" }}>
          Po co się tu zebraliśmy?
        </p>

        {/* Steps */}
        <div style={{ display: "flex", flexDirection: "column", gap: "36px", width: "100%", maxWidth: "940px" }}>
          <div style={{ display: "flex", gap: "24px", alignItems: "flex-start", paddingLeft: "48px", paddingRight: "48px" }}>
            <div style={{ background: "rgba(78, 138, 110, 0.15)", borderRadius: "50%", width: "68px", height: "68px", minWidth: "68px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "38px" }}>🔍</span>
            </div>
            <div>
              <p style={{ fontSize: "34px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 6px", lineHeight: 1.3 }}>
                Sprawdź czego potrzebują schroniska
              </p>
              <p style={{ fontSize: "30px", fontWeight: 600, color: "#5A8A70", margin: 0, lineHeight: 1.4 }}>
                Na stronie znajdziesz mapę schronisk z aktualnymi potrzebami - karma, koce, wolontariusze do spacerów
              </p>
            </div>
          </div>

          <div style={{ display: "flex", gap: "24px", alignItems: "flex-start", paddingLeft: "48px", paddingRight: "48px" }}>
            <div style={{ background: "rgba(78, 138, 110, 0.15)", borderRadius: "50%", width: "68px", height: "68px", minWidth: "68px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "38px" }}>🤝</span>
            </div>
            <div>
              <p style={{ fontSize: "34px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 6px", lineHeight: 1.3 }}>
                Pomóż rozbudować mapę
              </p>
              <p style={{ fontSize: "30px", fontWeight: 600, color: "#5A8A70", margin: 0, lineHeight: 1.4 }}>
                Znasz schronisko, którego nie ma na mapie?
                <br />
                Dodaj je albo podrzuć im link do strony - będą mogli aktualizować na bieżąco swoje potrzeby
              </p>
            </div>
          </div>

          {/* Step 3 - highlighted */}
          <div
            style={{
              display: "flex",
              gap: "24px",
              alignItems: "flex-start",
              background: "rgba(255,255,255,0.95)",
              borderRadius: "24px",
              padding: "28px 36px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
              border: "3px solid #4E8A6E",
              marginLeft: "-8px",
              marginRight: "-8px",
            }}
          >
            <div style={{ background: "rgba(78, 138, 110, 0.15)", borderRadius: "50%", width: "68px", height: "68px", minWidth: "68px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: "38px" }}>📢</span>
            </div>
            <div>
              <p style={{ fontSize: "34px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 6px", lineHeight: 1.3 }}>
                Zostań z nami na dłużej
              </p>
              <p style={{ fontSize: "30px", fontWeight: 700, color: "#2D5A3D", margin: 0, lineHeight: 1.4 }}>
                Obserwuj to konto - będę tu regularnie udostępniać zweryfikowane, pilne potrzeby schronisk, żebyś zawsze wiedział/a jak i gdzie pomóc
              </p>
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: "0 80px 100px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
